import { AnyAction } from "redux";
import ActionTypes from '../../../constants/ActionTypes';
import { ISSOTestStore } from "./types";

const initialState: ISSOTestStore = {
  platform: [],
  roles: [],
  landingPages: [],
  token: '',
};

const SSOTestReducer = (
  state = initialState,
  action: AnyAction,
): ISSOTestStore => {
  switch (action.type) {
  case ActionTypes.SSO.SET_SSO_TEST_DATA:
    return {
      ...state,
      platform: action.payload.platform,
      roles: action.payload.roles,
      landingPages: action.payload.landingPages
    };
  case ActionTypes.SSO.SET_SSO_TEST_TOKEN:
    return {
      ...state,
      token: action.payload.token
    };
  }
  return state;
};

export default SSOTestReducer;
